import store from '@/store/store.js'
import { ConstPaths } from '@/config/pathConfig'
import * as signalR from '@aspnet/signalr'
import kebabcase from "lodash.kebabcase";

var SubscriptionModuleId = ''
var UserId = ''
export var connectionStarted = false

export const signalRClientMethods = {
  connect : 'Connected',
  disconnect: 'Disconnected',
  join: 'JoinGrouped',
  send: 'SendToGroupCompleted',
  typing: 'UserTypingStart',
  delete: 'DeleteMessage',
  update: 'UpdateMessage',
  userChecking: 'UserChecking',
  connectionChecking: 'ConnectionChecking'
}

export const signalRServerMethods = {
  join: 'JoinGroup',
  send: 'SendToGroupWithMedia',
  delete: 'DeleteMessage',
  update: 'UpdateMessage',
  userChecking: 'UserChecking',
  connectionChecking: 'ConnectionChecking'
}

export const signalRCallbacks = {
  sendCallback: null,
  typingCallback: null,
  deleteCallback: null,
  updateCallback: null,
  userCheckingCallback: null,
  connectionWarningCallback: null,
  handleUserCheckCallback: null,
  closeWarning: null,
  reconnectingCallback: null,
  connectionCheckingCallback: null
}

export const getActiveConnection = () => {
  return store.getters.Connection
}

export const setActiveConnection = (connection) => {
  store.dispatch('setConnection',connection)
}

export const setAllConnections = (connection) => {
  store.dispatch('setConnections', [])
}

function getConnection () {
    let con = getConnectionByModuleId()
    if (con)
        return con.Connection
    return null
  }

function getConnectionByModuleId () {
  return store.getters.ConnectionList ? store.getters.ConnectionList.find(c => c.SubscriptionModuleId === SubscriptionModuleId) : null
}

export const addConnection = (subscriptionModuleId, connection) => {
  store.getters.ConnectionList.push({'SubscriptionModuleId': subscriptionModuleId, 'Connection': connection})
  store.dispatch('setConnections', store.getters.ConnectionList)
  setActiveConnection(connection)
}

export const isConnectionClosed = (connection) => {
  var isClosed = true
  if (UserId !== '' && connection && connection.connection) {
    switch (connection.connection.connectionState) {
      case 0:
      case 1:
      isClosed = false
      break;
    } 
  }
  return isClosed
}

export const getChannels = () => {
  return store.getters.Chat.ChatsChannels.map(channel => channel.id)
}

export const madeConnection = async (subscriptionModuleId, userId) => {
  SubscriptionModuleId = subscriptionModuleId
  UserId = userId
  if (UserId !== '') {
    let connectionObj = getConnectionByModuleId()
    if (connectionObj) {
      setActiveConnection(connectionObj.Connection)
      if(isConnectionClosed(connectionObj.Connection)) {
        await startConnection(connectionObj.Connection)
      } else {
        joinGroups(getChannels())
      }
    } else {
      let connection = buildConnection()
      bindMethods(connection)
      addConnection(subscriptionModuleId, connection)
      await startConnection(connection)
    }
  }
}

export const bindMethods = (connection) => {
  onConnected(connection)
  onDisconnected(connection) 
  onJoin(connection)
  onClosed(connection)
  onSend(connection)
  onTyping(connection)
  onDelete(connection)
  onUpdate(connection)
  onUserCheck(connection)
  onConnectionCheck(connection)
}

export const buildConnection = () => {
  return new signalR.HubConnectionBuilder()
        .withUrl(ConstPaths.chatHubUrl)
        .configureLogging(signalR.LogLevel.Error)
        .build()
}

export const startConnection = async (connection) => {
  if(isConnectionClosed(connection)) {
    await connection.start().then(() => {
      connectionStarted = true
      joinGroups(getChannels())
      //handleReconnection()
    }).catch(err => {
      connectionStarted = false
      console.log('start again', '' + err)
    })
  }
}

export const stopConnection = async () => {
  let con = getConnection()
  if (con) {
    await con.stop().then(() => {
      console.log('stop-connection', con)
    })
  }
}

export const resetConnections = async () => {
  stopConnection()
  setActiveConnection(null)
  setAllConnections([])
}

export const joinGroups = (channelList) => {
  invoke(signalRServerMethods.join, channelList)
}

export const onConnected = (connection) => {
  connection.on(signalRClientMethods.connect, connectCallback)
}

export const connectCallback = (msg) => {
  console.log('Connected successfully', msg)
  //if (!connectionStarted) {
  if (signalRCallbacks.reconnectingCallback) {
    signalRCallbacks.reconnectingCallback()
  }
  //}
}

export const onDisconnected = (connection) => {
  connection.on(signalRClientMethods.disconnect, disconnectCallback);
}

export const disconnectCallback = (msg) => {
  console.log('Disconnected', msg)
  handleConnection()
}

export const onJoin = (connection) => {
  connection.on(signalRClientMethods.join, joinCallback)
}

export const joinCallback = (msg) => {
  //console.log('Joined Group', msg)
}

export const onClosed = (connection) => {
  connection.onClosed = e => {
    connectionStarted = false
    if (e) {
      console.log('onClosed', 'Connection closed with error: ' + e)  
    } else {
      console.log('onClosed', 'Disconnected')  
    }
    handleConnection()
  }
}

export const onSend = (connection) => {
  if (signalRCallbacks.sendCallback)
    connection.on(signalRClientMethods.send, signalRCallbacks.sendCallback)
}

export const onTyping = (connection) => {
  if (signalRCallbacks.typingCallback)
    connection.on(signalRClientMethods.typing, signalRCallbacks.typingCallback)
}

export const onDelete = (connection) => {
  if (signalRCallbacks.deleteCallback)
    connection.on(signalRClientMethods.delete, signalRCallbacks.deleteCallback)
}

export const onUpdate = (connection) => {
  if (signalRCallbacks.updateCallback)
    connection.on(signalRClientMethods.update, signalRCallbacks.updateCallback)
}

export const onUserCheck = (connection) => {
  if (signalRCallbacks.userCheckingCallback)
    connection.on(signalRClientMethods.userChecking, signalRCallbacks.userCheckingCallback)
}

export const onConnectionCheck = (connection) => {
  if (signalRCallbacks.connectionCheckingCallback)
    connection.on(signalRClientMethods.connectionChecking, signalRCallbacks.connectionCheckingCallback)
}

export const handleReconnection = () => {
  store.dispatch('setResetReconnectingFlag', true)
}

export const handleConnectionChecking = () => {
  invoke(signalRServerMethods.connectionChecking, UserId)
}

export const handleConnection = () => {
  var con = getConnection()
  if(isConnectionClosed(con)) {
    if (signalRCallbacks.connectionWarningCallback)
      signalRCallbacks.connectionWarningCallback()
    startConnection(con)
  }
}

export const invoke = (method, ...args) => {
  var con = getConnection()
  if(isConnectionClosed(con)) {
    handleConnection()
  } else if (connectionStarted && UserId !== ''){
    invokeHandler(con, method, ...args)
  }
}

export const invokeHandler = (connection, method, ...args) => {
  if (connection) {
    connection.invoke.apply(connection, [method, ...args]).then(result => {
    if (result) {
      console.log('successfully invoked', result)
    }
    }).catch(err => {
      connectionStarted = false
      console.log('invoke with error', err)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/SignalRHelper/index.js